/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.general-listing[_ngcontent-%COMP%] {\n  color: #ffffff;\n  background: #9c0c2b;\n  font-style: oblique;\n  padding: 2px 10px 2px 10px;\n  border-radius: 5px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvZGVwYXJ0bWVudHMvZGVwYXJ0bWVudHMuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvZGVwYXJ0bWVudHMvZGVwYXJ0bWVudHMuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/departments/departments.component.scss.shim.ngstyle.ts